import type { Account } from "../types";
import { statusInfo, price, money2, num } from "../format";
import PriceChart from "./PriceChart";

function posLine(a: Account) {
  const p = a.position;
  if (!p) return <span className="muted">Flat — no open position</span>;
  const long = (p.side ?? 0) > 0;
  const u = p.unrealized_pnl;
  return (
    <span>
      <span className={`side-pill ${long ? "long" : "short"}`}>{long ? "▲ LONG" : "▼ SHORT"}</span>{" "}
      @ {price(p.entry_price)}{" "}
      {u != null && <span className={u >= 0 ? "win" : "loss"}>({money2(u)})</span>}
    </span>
  );
}

/** All instruments at once — one compact price-chart card each. */
export default function InstrumentGrid({ accounts, onOpen }:
  { accounts: Account[]; onOpen: (id: string) => void }) {
  if (accounts.length === 0) return <p className="muted">No instruments registered.</p>;
  return (
    <div className="inst-grid">
      {accounts.map((a) => {
        const s = statusInfo(a.status);
        return (
          <article key={a.account_id} className="card inst-card" aria-labelledby={`ic-${a.account_id}`}>
            <header className="inst-card-head">
              <button id={`ic-${a.account_id}`} className="inst-title linklike" onClick={() => onOpen(a.account_id)}>
                {a.instrument} <span className="muted">· {a.tf}</span>
              </button>
              <span className={s.cls}><span aria-label={s.sr}>{s.label}</span></span>
            </header>
            <div className="inst-card-pos">{posLine(a)}</div>
            <PriceChart bars={a.bars ?? []} trades={a.trades ?? []} position={a.position}
              label={a.instrument} height={200} />
            <footer className="inst-card-foot">
              <span>{num(a.metrics?.n_trades, 0)} trades</span>
              <span>PF {num(a.metrics?.profit_factor)}</span>
              <span>P&amp;L {money2(a.metrics?.total_pnl)}</span>
              <button className="linklike" onClick={() => onOpen(a.account_id)}>Open →</button>
            </footer>
          </article>
        );
      })}
    </div>
  );
}
